import { formatDate } from ".";

export function checkKnownDateOrString(e, f) {
  if (
    e === "date" ||
    e === "dateSupplierAdded" ||
    e === "requestDate" ||
    e === "productionDate" ||
    e === "expiryDate" ||
    e === "receiptDate" ||
    e === "deliveredDate" ||
    e === "dateModified" ||
    e === "needByDate" ||
    e === "previousDate" ||
    e === "updateDate"
  ) {
    // return new Date(f).toISOString().replace(/T.+/, "");
    if (f === "pending" || f === "N/A") {
      return f;
    } else {
      return formatDate(f);
    }
    // return formatDateAndTime(f);
  } else if (e === "duration") {
    return f + " Days";
  } else if (e === "amount") {
    return f + " /-";
  } else if (f === "") {
    return "N/A";
  } else {
    return f;
  }
}
